var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6 9)",
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 3v18h24V3H3zM0 1.501C0 .672.683 0 1.488 0h27.024C29.334 0 30 .667 30 1.501V22.5c0 .829-.683 1.501-1.488 1.501H1.488A1.491 1.491 0 0 1 0 22.499V1.5z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.874 13.312c.079-.002.349.014.714.06.638.079 1.356.223 2.135.448 2.247.652 4.502 1.829 6.616 3.667 1.873 1.629 3.547 3.709 4.971 6.298l2.629-1.446c-1.594-2.897-3.491-5.255-5.631-7.115-2.457-2.138-5.1-3.517-7.75-4.285-1.615-.468-2.853-.622-3.684-.627v3zM19.334 17.464c.085-.07.28-.218.574-.417a14.805 14.805 0 0 1 1.749-1.012c2.205-1.087 4.603-1.649 7.079-1.417l.28-2.986c-3.085-.29-6.018.397-8.685 1.712-1.35.666-2.345 1.339-2.917 1.815l1.92 2.305z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.75,
    cy: 8.25,
    r: 2.25
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.25e42da46bdfd64d2d67b91060159a17.svg";
export { ForwardRef as ReactComponent };